module.exports = __webpack_public_path__ + "img/des01.c4b0e2bc.png";